import { connect } from 'react-redux';
import { get } from 'lodash';
import { createNote, deleteNote, updateNote } from 'actions';
import { getWebNotes } from 'selectors';
import QuestionNotes from 'components/notes/QuestionNotes';

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
    notes: getWebNotes(state.modal.meta, ownProps.asqQuestionId),
    params: ownProps.params,
    qNumber: ownProps.qNumber,
    question: get(state.player.survey, `entities.questions[${ownProps.asqQuestionId}]`),
  }
}

export default connect(mapStateToProps, { createNote, deleteNote, updateNote })(QuestionNotes);
